<div class="container-fluid">
  <div class="container">
    <div class="container-fluid ">
      <div class="row mt-4">
        <div class="col-sm-7 text-left">
          <h4 class="mb-0">{{'Hello'}}, {{userDetail?.fullName}}</h4>
        </div>
        <div class="col-sm-5  text-right">
          <label>Last refreshed on : {{lastRefreshTime}}</label>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-6 mb-2">
          <div class="chartBorder">
            <h5 class="p-2 font-size-17px text-center">Quotations</h5>
            <div class="chartHeight" id="certificateIssuance"></div>
          </div>
        </div>
        <div class="col-md-6 mb-2">
          <div class="chartBorder">
            <h5 class="p-2 font-size-17px text-center">Policies</h5>
            <div class="chartHeight" id="certificateExpiration"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>